module.exports = __webpack_public_path__ + "media/images/logos/06-89e56c45349b1b8add2b99fda54c0679.png";